import update from "immutability-helper";
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchElencoProntoSoccorsoSuccess,
  fetchElencoProntoSoccorsoFailed,
  fetchCodiciColoreSuccess,
  fetchCodiciColoreFailed,
  fetchFaqSuccess,
  fetchFaqFailed,
  fetchCookiePolicySuccess,
  fetchCookiePolicyFailed,
  fetchContactsSuccess,
  fetchContactsFailed,
  fetchPrivacyPsSuccess,
  fetchPrivacyPsFailed,
} from "./index";

export const initialState = {
  elencoProntoSoccorso: {
    data: null,
    fetchEnded: false,
  },
  codiciColore: {
    data: JSON.stringify(Array.from(new Map().entries())),
    fetchEnded: false,
  },
  faq: {
    data: JSON.stringify(Array.from(new Map().entries())),
    fetchEnded: false,
  },
  cookiePolicy: {
    data: JSON.stringify(Array.from(new Map().entries())),
    fetchEnded: false,
  },
  contacts: {
    data: JSON.stringify(Array.from(new Map().entries())),
    fetchEnded: false,
  },
  privacyPs: {
    data: JSON.stringify(Array.from(new Map().entries())),
    fetchEnded: false,
  },
  monitoraggio: {
    data: [],
    fetchEnded: false,
  },
};

const fetchElencoProntoSoccorsoSuccessHandler = (state, action) => {
  return update(state, {
    elencoProntoSoccorso: {
      data: { $set: action.payload },
      fetchEnded: { $set: true },
    },
  });
};

const fetchElencoProntoSoccorsoFailedHandler = (state) => {
  return update(state, {
    elencoProntoSoccorso: {
      data: { $set: [] },
      fetchEnded: { $set: true },
    },
  });
};

const fetchCodiciColoreSuccessHandler = (state, action) => {
  const { locale, data } = action.payload;
  let codiciColoreStored = new Map(JSON.parse(state.codiciColore.data));
  if (codiciColoreStored.get(locale) == null) codiciColoreStored.set(locale, data);
  return update(state, {
    codiciColore: {
      data: { $set: JSON.stringify(Array.from(codiciColoreStored.entries())) },
      fetchEnded: { $set: true },
    },
  });
};

const fetchCodiciColoreFailedHandler = (state) => {
  return update(state, {
    codiciColore: {
      fetchEnded: { $set: true },
    },
  });
};

const fetchFaqSuccessHandler = (state, action) => {
  const { locale, data } = action.payload;
  let faqStored = new Map(JSON.parse(state.faq.data));
  if (faqStored.get(locale) == null) faqStored.set(locale, data);
  return update(state, {
    faq: {
      data: { $set: JSON.stringify(Array.from(faqStored.entries())) },
      fetchEnded: { $set: true },
    },
  });
};

const fetchFaqFailedHandler = (state) => {
  return update(state, {
    faq: {
      fetchEnded: { $set: true },
    },
  });
};

const fetchCookiePolicySuccessHandler = (state, action) => {
  const { locale, data } = action.payload;
  let cookiePolicyStored = new Map(JSON.parse(state.cookiePolicy.data));
  if (cookiePolicyStored.get(locale) == null) cookiePolicyStored.set(locale, data);
  return update(state, {
    cookiePolicy: {
      data: { $set: JSON.stringify(Array.from(cookiePolicyStored.entries())) },
      fetchEnded: { $set: true },
    },
  });
};

const fetchCookiePolicyFailedHandler = (state) => {
  return update(state, {
    cookiePolicy: {
      fetchEnded: { $set: true },
    },
  });
};

const fetchContactsSuccessHandler = (state, action) => {
  const { locale, data } = action.payload;
  let contactsStored = new Map(JSON.parse(state.contacts.data));
  if (contactsStored.get(locale) == null) contactsStored.set(locale, data);
  return update(state, {
    contacts: {
      data: { $set: JSON.stringify(Array.from(contactsStored.entries())) },
      fetchEnded: { $set: true },
    },
  });
};

const fetchContactsFailedHandler = (state) => {
  return update(state, {
    contacts: {
      fetchEnded: { $set: true },
    },
  });
};

const fetchPrivacyPsSuccessHandler = (state, action) => {
  const { locale, data } = action.payload;
  let privacyPsStored = new Map(JSON.parse(state.privacyPs.data));
  if (privacyPsStored.get(locale) == null) privacyPsStored.set(locale, data);
  return update(state, {
    privacyPs: {
      data: { $set: JSON.stringify(Array.from(privacyPsStored.entries())) },
      fetchEnded: { $set: true },
    },
  });
};

const fetchPrivacyFailedPsHandler = (state) => {
  return update(state, {
    privacyPs: {
      fetchEnded: { $set: true },
    },
  });
};

const prontoSoccorsoSlice = createSlice({
  name: "prontoSoccorso",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchElencoProntoSoccorsoSuccess, (state, action) => fetchElencoProntoSoccorsoSuccessHandler(state, action));
    builder.addCase(fetchElencoProntoSoccorsoFailed, (state) => fetchElencoProntoSoccorsoFailedHandler(state));
    builder.addCase(fetchCodiciColoreSuccess, (state, action) => fetchCodiciColoreSuccessHandler(state, action));
    builder.addCase(fetchCodiciColoreFailed, (state) => fetchCodiciColoreFailedHandler(state));
    builder.addCase(fetchFaqSuccess, (state, action) => fetchFaqSuccessHandler(state, action));
    builder.addCase(fetchFaqFailed, (state) => fetchFaqFailedHandler(state));
    builder.addCase(fetchCookiePolicySuccess, (state, action) => fetchCookiePolicySuccessHandler(state, action));
    builder.addCase(fetchCookiePolicyFailed, (state) => fetchCookiePolicyFailedHandler(state));
    builder.addCase(fetchContactsSuccess, (state, action) => fetchContactsSuccessHandler(state, action));
    builder.addCase(fetchContactsFailed, (state) => fetchContactsFailedHandler(state));
    builder.addCase(fetchPrivacyPsSuccess, (state, action) => fetchPrivacyPsSuccessHandler(state, action));
    builder.addCase(fetchPrivacyPsFailed, (state) => fetchPrivacyFailedPsHandler(state));
  },
});

export const prontoSoccorsoReducer = prontoSoccorsoSlice.reducer;
